export default function BotonDiv({ tituloBoton, onClick }) {
  return (
    <div onClick={onClick} className="botonCard">
      {tituloBoton}
    </div>
  );
}
